import { RadioBox } from './RadioBox';
import { CheckboxGroup } from './CheckboxGroup';
import InfoBulle from './InfoBulle';

const partsFiscalesInfo = (
  <>
    <p>
      Ce chiffre figure sur votre avis d&apos;imposition, ligne « Nombre de parts »
      (1<sup>re</sup> page, cadre « Vos revenus »).
    </p>
    <p>
      <strong>Repères :</strong>
    </p>
    <ul>
      <li>1 part si vous êtes seul(e) (célibataire, divorcé, séparé, veuf)</li>
      <li>2 parts si vous êtes en couple (marié ou pacsé)</li>
      <li>Puis + 0,5 part pour chacun des 2 premiers enfants à charge</li>
      <li>+ 1 part à partir du 3<sup>e</sup> enfant</li>
    </ul>
  </>
);

export default function QuestionStep({
  question,
  answers,
  onRadioChange,
  onCheckboxChange,
  onFieldChange,
}) {
  if (!question) return null;

  if (question.type === 'radio') {
    return (
      <div className="question-step">
        <h3>{question.question}</h3>
        {question.conditions?.length > 0 && (
          <ul className="conditions-list">
            {question.conditions.map((condition) => (
              <li key={condition}>{condition}</li>
            ))}
          </ul>
        )}
        <RadioBox
          name={question.id}
          options={question.options}
          value={answers[question.id]}
          onChange={(value) => onRadioChange(question.id, value)}
        />
      </div>
    );
  }

  if (question.type === 'checkbox') {
    return (
      <div className="question-step">
        <CheckboxGroup
          name={question.id}
          options={question.options}
          values={answers[question.id] || []}
          onChange={(values) => onCheckboxChange(question.id, values)}
        >
          <h3>{question.question}</h3>
        </CheckboxGroup>
      </div>
    );
  }

  if (question.type === 'group') {
    return (
      <div className="question-step question-group">
        <h3>{question.question}</h3>
        {question.description && <p className="question-description">{question.description}</p>}
        <div className="group-fields">
          {question.fields.map((field) => (
            <div key={field.id} className="field">
              <div className="field-label-row">
                <label htmlFor={field.id}>
                  {field.label}
                  {field.unit ? ` (${field.unit})` : ''}
                </label>
                {field.id === 'parts_fiscales' && <InfoBulle message={partsFiscalesInfo} />}
              </div>
              <input
                id={field.id}
                name={field.id}
                type="number"
                min={field.min}
                step={field.id === 'parts_fiscales' ? '0.5' : '1'}
                placeholder={field.id === 'rfr' ? 'Ex : 18000' : 'Ex : 2'}
                value={answers[field.id] ?? ''}
                onChange={(e) => onFieldChange(field.id, e.target.value)}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return null;
}
